import React, { useMemo } from 'react';
import { Autocomplete, TextField, FormControl, InputLabel, Select, MenuItem } from '@mui/material';

const InterviewResultForm = ({ formState, formActions }) => {
  const {
    interViewerName, hrnames, isRestricted,
    result, round, roundResult, propsInterview,
    feedback, prevfeedback, egr, cmr
  } = formState;

  const {
    setInterViewerName, setResult, setFeedback, 
    setMobileStatus, setEgr, setCmr
  } = formActions;

  const quickFeedbackOptions = useMemo(() => ({
    "Not Reachable": [
      { label: "Switched Off", feedback: "Switched Off", status: "Your number is switched off." },
      { label: "Not received", feedback: "Not received call", status: "Your number is not reachable." },
      { label: "Out of network", feedback: "Out of network", status: "Your number is out of network." },
      { label: "Another call", feedback: "On another call", status: "Your number is busy on another call." },
      { label: "Disconnecting", feedback: "Disconnecting", status: "We are unable to connect with you." },
      { label: "Other Person Picked", feedback: "Some other person received the call.", status: "Some other person received our call." }
    ],
    "Rejected": [
      { label: "Worst Comm", feedback: "Worst Communication" }, { label: "Poor Comm", feedback: "Poor Communication" },
      { label: "WFH", feedback: "Needs work from home" }, { label: "Part Time", feedback: "Needs Part Time Job" },
      { label: "Non Voice", feedback: "Needs non Voice Job" }, { label: "High salary", feedback: "Needs High salary" },
      { label: "Not interested", feedback: "Not interested" }
    ],
    "Next Round": [
      { label: "Voice", feedback: "Selected for Voice Process." }, { label: "Non-Voice", feedback: "Selected for Non-Voice Process." },
      { label: "WFH", feedback: "Selected for work from home Process." }
    ],
    "Cancelled": [
      { label: "Not Interested", feedback: "Not interested" }, { label: "Duplicate", feedback: "Duplicate Record" }
    ],
  }), []);

  return (
    <>
      <div className='Interviewer_Name_txt'>
        <Autocomplete disablePortal id="Interviewer_Name_txt" freeSolo options={hrnames} sx={{ width: 270 }} value={interViewerName || ""} disabled={isRestricted} onChange={(event, value) => setInterViewerName(value)}
          renderInput={(params) => <TextField {...params} sx={{ width: 270 }} size="small" label="Interviewer Name" disabled={isRestricted} value={interViewerName || ""} onChange={(e) => { setInterViewerName(e.target.value); }} />}
        />
      </div>

      <div style={{ textAlign: "center", color: "cornflowerblue", fontWeight: "bold" }} className='Interview_result_txt'>
        <FormControl variant="outlined" sx={{ minWidth: 270 }} size="small"  >
          {(roundResult && (roundResult === "Next Round" || roundResult === "Passed")) ? "Interview Result:Passed" :
            <>
              <InputLabel id="demo-simple-select-label">Interview Result</InputLabel>
              <Select labelId="demo-simple-select-labell" id="demo-simple-select" value={result || ""} onChange={(e) => { setResult(e.target.value); }} >
                {round !== "Joined" ? <MenuItem value="Applied">Applied</MenuItem> : <></>}
                {round !== "Joined" ? <MenuItem value="Scheduled">Scheduled</MenuItem> : <></>}
                {round !== "Joined" ? <MenuItem value="Not Reachable">Not Reachable</MenuItem> : <></>}
                {round !== "Joined" ? <MenuItem value="Rejected">Failed</MenuItem> : <></>}
                {round !== "Joined" && round !== "Client Round" ? <MenuItem value="Next Round">Passed</MenuItem> : <></>}
                {round !== "Joined" ? <MenuItem value="Cancelled">Cancelled</MenuItem> : <></>}
                {round === "Client Round" ? <MenuItem value="Selected">Selected</MenuItem> : <></>}
                {round === "Client Round" ? <MenuItem value="Not Joined">Selected & Not Joined</MenuItem> : <></>}
                {round === "Client Round" ? <MenuItem value="Joined">Joined</MenuItem> : <></>}
                {round === "Joined" ? <MenuItem value="Joined & Left">Joined & Left</MenuItem> : <></>}
                {round === "Joined" ? <MenuItem value="Invoiced">Invoiced</MenuItem> : <></>}
              </Select>
            </>
          }
        </FormControl>
      </div>

      <div className='Suggestion_for_Interview'>
        {(quickFeedbackOptions[result] || []).map((opt, idx) => (
          <button 
            type="button" 
            key={idx} 
            style={{ margin: "2px", border: "1px solid", padding: "2px 6px" }} 
            onClick={() => {
              if (result === "Next Round") setFeedback(prev => prev.includes(opt.feedback) ? prev.replace(` ${opt.feedback}`, "").replace(opt.feedback, "") : (prev === "" ? "" : prev + " ") + opt.feedback);
              else setFeedback(opt.feedback);
              if (opt.status) setMobileStatus(opt.status);
            }}
          >
            {opt.label}
          </button>
        ))}

        {(["Rejected", "Not Reachable", "Cancelled", "Next Round"].includes(result)) && (
          <button 
            type="button" 
            style={{ margin: "2px", border: "1px solid", padding: "2px 6px" }} 
            onClick={() => { setFeedback(""); setMobileStatus(""); }}
          >
            Clear
          </button>
        )}
      </div>

      <div className='English_Rating_txt'>
        <FormControl variant="outlined" sx={{ width: 270, marginTop: "2px" }} size="small"  >
          <InputLabel id="English_Rating_txt-label" > English Ratings</InputLabel>
          <Select labelId="demo-simple-select-labell" id="English_Rating_txt" value={egr} onChange={(e) => { setEgr(e.target.value); }} >
            <MenuItem value={5}>A - Excellent</MenuItem><MenuItem value={4}>B - Good</MenuItem><MenuItem value={3}>C - Average</MenuItem><MenuItem value={2}>D - Bad</MenuItem><MenuItem value={1}>E - Pathetic</MenuItem>
          </Select>
        </FormControl>
      </div>

      <div className='Communication_Rating_txt'>
        <FormControl variant="outlined" sx={{ width: 270, marginTop: "2px" }} size="small"  >
          <InputLabel id="Communication_Rating_txt-label"  >Communication Ratings</InputLabel>
          <Select labelId="demo-simple-select-labell" id="Communication_Rating_txt" value={cmr} onChange={(e) => { setCmr(e.target.value); }} >
            <MenuItem value={5}>A - Excellent</MenuItem><MenuItem value={4}>B - Good</MenuItem><MenuItem value={3}>C - Average</MenuItem><MenuItem value={2}>D - Bad</MenuItem><MenuItem value={1}>E - Pathetic</MenuItem>
          </Select>
        </FormControl>
      </div>

      <div className='Previous_Feedback_txt'>
        <TextField id="outlined-multiline-flexible" sx={{ width: 290 }} style={{ marginRight: "20px" }} size="small" label="Previous Feedback" multiline rows={4} value={prevfeedback || ""} InputProps={{ readOnly: true, }} />
      </div>

      <div className='Enter_your_feedback_txt'>
        <TextField id="Enter_your_feedback_txt" sx={{ width: 290, marginBottom: "0px" }} size="small" label="Enter Your Feedback" multiline rows={2} value={feedback || ""} onChange={(e) => { setFeedback(e.target.value); }} />
      </div>
    </>
  );
};

export default InterviewResultForm;